import moment from "moment";

export default function formatDate(date: Date | number) {
  const formattedDate = moment(date).format("YYYY-MM-DD-hh:mm A");
  return formattedDate.replace(" ", "-").replace(":", "_");
}
